import { useParams } from 'react-router-dom';
import useApiQuery from '../useApiQuery';
import keys from './keys';

const useGetShowRedirected = ({ showId: showIdParam, checkItunes, checkImport, isImported }) => {
  const { showId: currentShowId } = useParams();
  const showId = showIdParam || currentShowId;

  const withItunes = showId && isImported && checkItunes;
  const withImport = showId && isImported && checkImport;

  const queryTraceFeed = useApiQuery({
    requestUrl: `/shows/${showId}/check-redirect`,
    disabled: !withImport,
    queryKey: keys(showId).showCheckRedirectFeed(false),
  });

  const queryItunesLookup = useApiQuery({
    requestUrl: `/shows/${showId}/check-redirect?itunes=1`,
    disabled: !withItunes,
    queryKey: keys(showId, checkItunes).showCheckRedirectFeed(true),
  });

  const data = {
    import: checkImport ? queryTraceFeed?.data : null,
    importItunes: checkItunes ? queryItunesLookup?.data : null,
  };

  const isSuccess =
    (withImport ? queryTraceFeed.isSuccess : true) &&
    (withItunes ? queryItunesLookup.isSuccess : true);

  return {
    checkImport: () => {
      queryTraceFeed.refetch();
      queryItunesLookup.refetch();
    },
    isRedirected:
      data?.import?.redirected === true || data?.import?.redirected === 'feed not found',
    redirectionInfo: data,
    redirectionInfoError: queryTraceFeed.error || queryItunesLookup.error,
    isRedirectionInfoFetchError: queryTraceFeed.isError || queryItunesLookup.isError,
    isRedirectionInfoFetchSuccess: isSuccess,
    isRedirectionInfoFetching: queryTraceFeed.isFetching || queryItunesLookup.isFetching,
    isRedirectionInfoLoading: queryTraceFeed.isLoading || queryItunesLookup.isLoading,
  };
};

export default useGetShowRedirected;
